import { render, staticRenderFns } from "./CanvasSourceTab.vue?vue&type=template&id=cc4d4300&"
import script from "./CanvasSourceTab.vue?vue&type=script&lang=ts&"
export * from "./CanvasSourceTab.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./CanvasSourceTab.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports